const Secondary = {
  10: '#EEF4FA',
  20: '#5692C9',
};

export default Secondary;
